import handler from 'api/handler'

const prefix = '/userAdmin/chatCalls'

const methods = {
  token: args => handler({ method: 'post', url: `${prefix}/token`, args })
}

export default methods

